"use client"
import styled from "@emotion/styled"
import { GetPageQuery } from "apollo"
import { HomeIcon } from "ui/icons"

import { Container, CustomBreadcrumbs } from "ui"
import { BlockRenderer, findProperty } from "utils"
import RegulationWrapper from "./RegulationWrapper"

const StyledRegulation = styled.div`
  padding-bottom: 28px;
  ${(props) => props.theme.breakpoints.up("md")} {
    max-width: 753px;
    padding-bottom: 60px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    max-width: 1130px;
    padding-bottom: 80px;
  }
`

type Props = {
  data: GetPageQuery
  title?: string
  url?: string
}

function Regulation({ data, title, url }: Props) {
  const components = { contentText: RegulationWrapper }

  return (
    <Container padding={52}>
      <StyledRegulation>
        <CustomBreadcrumbs
          current={{ title: title || "תקנון המועדון", url: url || `/` }}
          parents={[{ title: <HomeIcon />, url: "/" }]}
        />
        {findProperty(data.page, "blocks")?.blocks?.map(
          // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
          (block: any, index: number) => (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
            >
              {null}
            </BlockRenderer>
          )
        )}
      </StyledRegulation>
    </Container>
  )
}

export default Regulation
